import Box from '@material-ui/core/Box';
import CopyrightIcon from '@material-ui/icons/Copyright';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FooterStyles } from '../styles/footer';
import { IELink } from '../../common/components/IELink';
import { Link as BrowserLink } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux-store/hook';

/** Footer Component */
const PostHireFooter = (): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const {
    settings: { footer },
  } = useAppSelector((state) => state.template);
  const { userSessionActive } = useAppSelector((state) => state.basicDetails);
  const classes = FooterStyles(footer);

  const DPNLabel = t('dataProtectionNotice');
  const CookieLabel = t('cookieSettings');

  const onClickCookieSettings = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    if (window.Cookiebot) {
      window.Cookiebot.renew();
    }
  };

  const getLinks = (): JSX.Element => {
    return (
      <Grid item xs>
        <Box display="flex" justifyContent="center" flexDirection={smUp ? 'row' : 'column'}>
          <Box>
            <Tooltip title={DPNLabel} PopperProps={{ 'aria-hidden': true }} id="">
              <Link
                component={BrowserLink}
                to={{
                  pathname: routeMappings['DPN'],
                  search: '?from=userProfile',
                }}>
                <IELink>{DPNLabel}</IELink>
              </Link>
            </Tooltip>
          </Box>

          <Box ml={smUp ? 2 : 0}>
            <Tooltip title={CookieLabel} PopperProps={{ 'aria-hidden': true }} id="">
              <Link href="#" onClick={onClickCookieSettings}>
                <IELink>{CookieLabel}</IELink>
              </Link>
            </Tooltip>
          </Box>
        </Box>
      </Grid>
    );
  };

  return (
    <>
      <footer className={classes.footer}>
        <Grid container>
          {userSessionActive && (
            <Grid item xs={12}>
              <Box textAlign="center" className={classes.utilityLink} mt={2}>
                <Grid container spacing={smUp ? 1 : 0}>
                  {getLinks()}
                </Grid>
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box textAlign="center">
              <Typography variant="subtitle2" className={classes.copyRightText}>
                <CopyrightIcon />
                {` ${new Date().getFullYear()} `}
                {t('allRightsReserved')}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </footer>
    </>
  );
};

export default PostHireFooter;
